import { render, staticRenderFns } from "./resultPage.vue?vue&type=template&id=8b95b82c&scoped=true&"
import script from "./resultPage.vue?vue&type=script&lang=js&"
export * from "./resultPage.vue?vue&type=script&lang=js&"
import style0 from "./resultPage.vue?vue&type=style&index=0&id=8b95b82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95b82c",
  null
  
)

export default component.exports